import { z } from 'zod';

export interface ApiResponse<T> {
  success: boolean;
  data: T | null;
  message: string;
}

export const createAssetSchema = z.object({
  name: z.string().min(1),
  tokenSymbol: z.string().min(1),
  comment: z.string().optional(),
  category: z.enum(['crypto', 'stock', 'commodity', 'index']),
  isMajor: z.boolean().default(false),
  marketCap: z.string().optional().or(z.literal(''))
});

export type CreateAssetData = z.infer<typeof createAssetSchema>;
